import {Box, Checkbox} from '@mui/material';
import {Navbar} from '../../../components/common/NavBar/NavBar';
import {PageWrapper} from '../../../components/common/PageWrapper/PageWrapper';
import {userScrollLimit} from '../LandingView/LandingViewStyles';
import {flexAlign} from '../../Private/ProfileView/ProfileViewStyles';
import {QuizNavigationButton} from '../../../components/common/QuizNavigationBtn/QuizNavigationButton';
import {useNavigate} from 'react-router-dom';
import {termsBox} from './RegistrationStyles';
import {useState} from 'react';
import {checkBoxLarge} from '../../../components/common/AvailabilityTable/AvailabilityTableStyles';
import {TermsOfUse} from '../../../components/common/GeneralTermsAndPrivacy/TermsOfUse';

export const TermsView = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  const handleCheck = () => setChecked(prev => !prev);

  const handleNext = () => {
    navigate('/privacy');
  };

  return (
    <>
      <Navbar cancelBtn backBtn signUp page="/" />
      <Box sx={userScrollLimit}>
        <PageWrapper title="Terms of Use">
          <Box sx={{p: 2}}>
            <Box sx={termsBox}>
              <TermsOfUse />
            </Box>
            <Box sx={{my: 3}}>
              <Box sx={flexAlign}>
                <Checkbox
                  checked={checked}
                  onChange={handleCheck}
                  sx={checkBoxLarge}
                />
                <Box sx={{fontSize: '12px'}}>
                  By checking this box I confirm that I have read and agree to
                  be bound by the Agreement above. I also confirm that I am of
                  the legal age of majority in the jurisdiction in which reside
                  (at least 18 years of age in many countries).
                </Box>
              </Box>
            </Box>
            <QuizNavigationButton
              leftDisabled
              rightDisabled={!checked}
              rightOnClick={handleNext}
            />
          </Box>
        </PageWrapper>
      </Box>
    </>
  );
};
